var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.7143V7.42857C0 7.06667 0.0796875 6.72381 0.239063 6.4C0.398438 6.07619 0.61875 5.80952 0.9 5.6L7.65 0.457143C8.04375 0.152381 8.49375 0 9 0C9.50625 0 9.95625 0.152381 10.35 0.457143L17.1 5.6C17.3812 5.80952 17.6016 6.07619 17.7609 6.4C17.9203 6.72381 18 7.06667 18 7.42857V17.7143C18 18.3429 17.7797 18.881 17.3391 19.3286C16.8984 19.7762 16.3688 20 15.75 20H12.375C12.0563 20 11.7891 19.8905 11.5734 19.6714C11.3578 19.4524 11.25 19.181 11.25 18.8571V13.1429C11.25 12.819 11.1422 12.5476 10.9266 12.3286C10.7109 12.1095 10.4437 12 10.125 12H7.875C7.55625 12 7.28906 12.1095 7.07344 12.3286C6.85781 12.5476 6.75 12.819 6.75 13.1429V18.8571C6.75 19.181 6.64219 19.4524 6.42656 19.6714C6.21094 19.8905 5.94375 20 5.625 20H2.25C1.63125 20 1.10156 19.7762 0.660938 19.3286C0.220313 18.881 0 18.3429 0 17.7143Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.14a15ff49af217b41a476e62351dc456.svg";
export { ForwardRef as ReactComponent };